<div class="controls-container">
    <div class="controls-header">Graph</div>
    
                            <!-- <pm-supplies-graph [AccountTimeSeries]="{}"
                                               [LinId]="'061382cb-e6c3-47e7-b6e4-f24cdcc76c9f'"
                                               [StartDate]="StartDate"
                                               [EndDate]="EndDate">
                            </pm-supplies-graph> -->
    <pm-graph [lineData]="ChartData"
          [pointData]="PointData"
          [height]=250
          [width]=900
          [AllowZoomY]=false
          [transitionDuration]=0
          [userColors]="['#377eb8','#984ea3','#4daf4a','#e41a1c']"
          [xDomain]="xDomain"
          [xExtent]="xExtent"
          [yDomain]="yDomain"
          [lineSizePx]="'3px'"
          [pointSizeR]="6"
          [interpolationMethod]="interpolationMethod"
          [disableWheelZoom]=true
          [includeLineDataPoints]=false
          [IncludeDifference]=true
          [margin]="Margin"
          [UseContinuousHoverLine]=false
          (TooltipItemChange)="tooltipItemChanged($event)">
        <div class="supplies-tooltip-container">
            <div *ngIf="TooltipItem"
                class="supplies-tooltip-element">
                <div class="supplies-tooltip-element">{{TooltipDateRange}}</div>
                <div class="supplies-tooltip-row supplies-tooltip-element"
                    *ngFor="let val of TooltipItem.values">
                    <div class="supplies-tooltip-item supplies-tooltip-element">{{val.seriesName}}:</div>
                    <div class="supplies-tooltip-item supplies-tooltip-element"> {{val.value.Value}}</div>
                </div>
            </div>
        </div>
    </pm-graph>
</div>




// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/graph/graph.html